module.exports = __webpack_public_path__ + "img/1160_MILR_Website_Heritage_04_02.1f925946.jpg";